export const configAiPrinciples = [
  {
    id: 'data',
    label: 'Data handling',
    title: 'Never used to train a model',
    description:
      "Your content answers your users' questions and nothing else — no training, and no retention beyond what the feature needs.",
  },
  {
    id: 'models',
    label: 'Model choice',
    title: 'Model-agnostic by default',
    description:
      'We build against an interface, not a vendor, so you can switch provider or self-host without a rewrite when pricing or policy shifts.',
  },
  {
    id: 'accuracy',
    label: 'Accuracy',
    title: 'Measured, not assumed',
    description:
      'Every AI feature ships with an evaluation set and a human review path, so you can see how often it is right before trusting it.',
  },
];
